import { For } from "solid-js";
import { t } from "../strings";
import { Tile } from "./Tile";

// What the tiles are (review 2026-11-01): a stranger reads man, pin and sou in the first lesson, and 一 and 東 in the first hand, and nothing said which
// was which. A plain copy of each kind, never a red five.
const RUNS = (from: number, n: number) => Array.from({ length: n }, (_, i) => from + i);

export function TileGuide() {
  return (
    <div class="tile-guide">
      <For each={t.tileGuide.rows}>
        {(row) => (
          <section>
            <h3>{row.name}</h3>
            <p class="small">{row.text}</p>
            <div class="tile-guide-row">
              <For each={RUNS(row.from, row.count)}>
                {(k, i) => (
                  <span class="tile-guide-tile">
                    <Tile id={k * 4 + 1} red={false} size="s" />
                    <small>{row.labels?.[i()] ?? i() + 1}</small>
                  </span>
                )}
              </For>
            </div>
          </section>
        )}
      </For>
    </div>
  );
}
